import { on } from "@ember/modifier";
import { computed } from "@ember/object";
import { htmlSafe } from "@ember/template";
import { classNames } from "@ember-decorators/component";
import { categoryBadgeHTML } from "discourse/helpers/category-link";
import icon from "discourse/helpers/d-icon";
import SelectedNameComponent from "select-kit/components/selected-name";
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
const SelectedCategory = dt7948.c(class SelectedCategory extends SelectedNameComponent {
  get badge() {
    return htmlSafe(categoryBadgeHTML(this.item, {
      allowUncategorized: true,
      link: false
    }));
  }
  static {
    dt7948.n(this.prototype, "badge", [computed("item")]);
  }
  static {
    setComponentTemplate(precompileTemplate("\n    <div {{on \"click\" this.onSelectedNameClick}} tabindex=\"0\" title={{this.title}} data-value={{this.value}} data-name={{this.name}} class=\"select-kit-selected-name selected-name choice\">\n      <div class=\"body\">\n        {{this.badge}}\n        {{icon \"xmark\"}}\n      </div>\n    </div>\n  ", {
      strictMode: true,
      scope: () => ({
        on,
        icon
      })
    }), this);
  }
}, [classNames("selected-category")]);
export default SelectedCategory;